import { makeSelectors } from '@utils/css';

const componentFrameworkSelectors = makeSelectors({
  isActive: "component-framework-active"
});

export { componentFrameworkSelectors };
//# sourceMappingURL=index.selectors.js.map
